import { createTheme, responsiveFontSizes } from "@mui/material/styles";

export const mainColor = "rgba(211, 211, 211, 0.3)";
export const backgroundColor = "#3980D1";

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

let theme = createTheme({
  palette: {
    primary: {
      main: mainColor,
    },
    background: {
      default: "#fff",
    },
  },
  typography: {
    // global font family (Poppins) used everywhere by default
    fontFamily: '"Poppins", sans-serif',
    allVariants: {
      color: "black",
    },
    // MOBILE / base sizes left unchanged
    h1: {
      fontSize: "4rem", // mobile
      "@media (min-width:600px)": {
        fontSize: "1.875rem",
      },
      "@media (min-width:960px)": {
        fontSize: "2.25rem",
      },
      fontWeight: 700,
      color: "#fff",
      textShadow: "0px 10px 20px rgba(166, 160, 160, 0.3)",
    },
    h2: {
      fontSize: "2.3rem",
      fontWeight: 600,
      "@media (min-width:600px)": {
        fontSize: "1.6875rem",
      },
      "@media (min-width:960px)": {
        fontSize: "2.0rem",
      },
      textShadow: "0px 10px 20px rgba(166, 160, 160, 0.3)",
    },
    h3: {
      fontSize: "0.90rem",
      fontWeight: 400,
      "@media (min-width:600px)": {
        fontSize: "0.75rem",
      },
      "@media (min-width:960px)": {
        fontSize: "2.0rem",
      },
      // color: backgroundColor,
      // h3 uses Poppins to stay consistent across the app
    },
    h4: {
      fontSize: "0.6rem",
      fontWeight: 400,
      "@media (min-width:600px)": {
        fontSize: "1.125rem",
      },
      "@media (min-width:960px)": {
        fontSize: "1.3125rem",
      },
    },
    h5: {
      fontSize: "1rem",
      fontWeight: 400,
      "@media (min-width:600px)": {
        fontSize: "0.9375rem",
      },
      "@media (min-width:960px)": {
        fontSize: "1.125rem",
      },
    },
    h6: {
      fontSize: "0.875rem",
      fontWeight: 400,
      "@media (min-width:600px)": {
        fontSize: "0.75rem",
      },
      "@media (min-width:960px)": {
        fontSize: "0.9375rem",
      },
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
      "@media (min-width:600px)": {
        fontSize: "0.9375rem",
      },
      "@media (min-width:960px)": {
        fontSize: "1.125rem",
      },
    },
    body2: {
      fontSize: "0.75rem",
      fontWeight: 400,
      "@media (min-width:600px)": {
        fontSize: "0.75rem",
      },
      "@media (min-width:960px)": {
        fontSize: "0.9375rem",
      },
    },
  },
  breakpoints: breakpoints,
  components: {}, // will attach safe overrides below
});

// attach component overrides using theme (so we can reference theme.breakpoints)
theme.components = {
  ...(theme.components || {}),
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        fontFamily: '"Poppins", sans-serif',
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: "none", // stop automatic uppercase
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 600,
        textColor: backgroundColor,
        letterSpacing: "0.02em",
        transition: "transform .18s ease, color .12s ease",
        [theme.breakpoints.down("sm")]: {
          fontSize: "2.0rem", // mobile: larger label
        },
        [theme.breakpoints.up("sm")]: {
          fontSize: "0.9rem", // tablet/desktop: smaller
        },
        "&:hover": {
          color: theme.palette.primary.main,
          transform: "translateY(-3px)",
        },
        "&.Mui-selected": {
          color: "black",
          transform: "none",
        },
        "&:focus-visible": {
          outline: "2px solid rgba(0,0,0,0.12)",
          outlineOffset: "3px",
        },
      },
    },
  },
  MuiRadio: {
    styleOverrides: {
      root: {
        color: "black",
        "&.Mui-checked": {
          color: "black",
        },
      },
    },
  },
};

theme = responsiveFontSizes(theme);

export default theme;
